import React from 'react';
import { useWidth, } from 'common/hooks';

import {
    DEBUG_MESSAGE_PREFIX,
    PRODUCTION,
} from 'common/constants';

const DebugFunctions = () => {
    const currentSizeScreen = useWidth();

    console.log(DEBUG_MESSAGE_PREFIX, 'Current screen size:', currentSizeScreen);

    return null;
};

const DebugTools = () => {
    if (process.env.NODE_ENV === PRODUCTION) {
        return null;
    }

    return (
        <DebugFunctions />
    );
};

export default DebugTools;
